// removed by extract-text-webpack-plugin
module.exports = {"button":"_52KFjT06Z1Hccj5pHHQJv"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ButtonIcon/style.css
 ** module id = 586
 ** module chunks = 0
 **/